import { render, staticRenderFns } from "./KanbanAvatarGroup.vue?vue&type=template&id=2e1dda8a&scoped=true"
import script from "./KanbanAvatarGroup.vue?vue&type=script&lang=js"
export * from "./KanbanAvatarGroup.vue?vue&type=script&lang=js"
import style0 from "./KanbanAvatarGroup.vue?vue&type=style&index=0&id=2e1dda8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1dda8a",
  null
  
)

export default component.exports